(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["heading-collection-slideshow"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('heading-collection-slideshow')){
 class CollectionHeadingSlideshow extends HTMLElement{
  connectedCallback(){
   if(this.events)return;
   this.events=new AbortController();this.slides=[...this.querySelectorAll('[data-ehs-slide]')];this.index=0;this.epoch=0;this.animations=[];this.hovered=false;this.inView=true;this.loading=false;
   this.slides.forEach((s,i)=>{s.hidden=i!==0;s.inert=i!==0;if(i)s.setAttribute('aria-hidden','true');else s.removeAttribute('aria-hidden');s.removeAttribute('data-outgoing');});
   this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.playing=this.dataset.autoplay==='true'&&this.slides.length>1&&!this.motion.matches;
   const on=(el,event,fn,options={})=>el.addEventListener(event,fn,{...options,signal:this.events.signal});
   on(this,'pointerdown',e=>{this.rotationPointer=!!e.target.closest('[data-ehs-pause]');if(this.dataset.swipe==='true'&&e.pointerType!=='mouse'&&!e.target.closest('button,a'))this.pointer={x:e.clientX,y:e.clientY,id:e.pointerId};},{passive:true});
   on(this,'pointerup',e=>{const p=this.pointer;this.pointer=null;if(!p||p.id!==e.pointerId)return;const dx=e.clientX-p.x,dy=e.clientY-p.y;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.4){this.suppressClick=Date.now()+500;this.show(this.index+(dx<0?1:-1)*(getComputedStyle(this).direction==='rtl'?-1:1),true);}},{passive:true});
   on(this,'pointercancel',()=>this.pointer=null);
   on(this,'click',e=>{if(Date.now()<(this.suppressClick||0)){e.preventDefault();e.stopImmediatePropagation();}},{capture:true});
   on(this,'click',e=>{if(e.target.closest('[data-ehs-pause]')){this.playing=!this.playing;this.rotationPointer=false;this.sync();return;}if(e.target.closest('[data-ehs-next]'))this.show(this.index+1,true);else if(e.target.closest('[data-ehs-prev]'))this.show(this.index-1,true);});
   on(this,'focusin',e=>{if(e.target.closest('[data-ehs-pause]')&&this.rotationPointer){this.rotationPointer=false;return;}this.playing=false;this.sync();});
   on(this,'mouseenter',()=>{this.hovered=true;this.sync();});on(this,'mouseleave',()=>{this.hovered=false;this.sync();});on(document,'visibilitychange',()=>this.sync());
   on(this.motion,'change',()=>{if(this.motion.matches)this.playing=false;this.sync();});
   on(document,'shopify:block:select',e=>{const slide=e.target.closest('[data-ehs-slide]');if(slide&&this.contains(slide))this.show(this.slides.indexOf(slide),true);});
   this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.sync();},{threshold:.15});this.observer.observe(this);
   this.querySelectorAll('[data-ehs-controls],[data-ehs-pause]').forEach(e=>e.hidden=false);this.dataset.ready='true';this.sync();this.warm(1);
  }
  disconnectedCallback(){this.events?.abort();this.events=null;clearTimeout(this.timer);this.epoch++;this.observer?.disconnect();this.animations?.forEach(a=>a.cancel());}
  warm(i){const image=this.slides[i]?.querySelector('img');if(image)image.loading='eager';return image;}
  async show(target,manual=false){
   if(manual)this.playing=false;
   const index=(target+this.slides.length)%this.slides.length;if(index===this.index){if(manual){this.epoch++;this.loading=false;this.animations.forEach(a=>a.cancel());this.slides.forEach((s,i)=>{s.hidden=i!==this.index;s.inert=i!==this.index;s.removeAttribute('data-outgoing');if(i!==this.index)s.setAttribute('aria-hidden','true');else s.removeAttribute('aria-hidden');});}this.sync();return;}
   const epoch=++this.epoch;clearTimeout(this.timer);this.loading=true;this.sync();const image=this.warm(index);
   if(image&&!image.complete){let deadline;try{await Promise.race([image.decode().catch(()=>{}),new Promise(r=>deadline=setTimeout(r,2000))]);}finally{clearTimeout(deadline);}}
   if(epoch!==this.epoch||!this.isConnected)return;
   this.loading=false;this.animations.forEach(a=>a.cancel());this.slides.forEach((s,i)=>{s.hidden=i!==this.index;s.removeAttribute('data-outgoing');});
   const movement=target>this.index?1:-1,old=this.slides[this.index],next=this.slides[index];old.inert=true;old.setAttribute('aria-hidden','true');next.hidden=false;next.inert=false;next.removeAttribute('aria-hidden');this.index=index;
   this.dataset.activeIndex=String(index);this.dataset.changeCount=String(Number(this.dataset.changeCount||0)+1);this.dataset.changeOrigin=manual?'manual':'automatic';
   if(!this.motion.matches&&this.dataset.transition!=='none'){
    old.dataset.outgoing='true';const slide=this.dataset.transition==='slide',direction=movement*(getComputedStyle(this).direction==='rtl'?-1:1);
    const a=old.animate(slide?[{opacity:1,transform:'translateX(0)'},{opacity:0,transform:'translateX('+(-direction*3)+'%)'}]:[{opacity:1},{opacity:0}],{duration:350,easing:'ease-out'});
    const b=next.animate(slide?[{opacity:0,transform:'translateX('+(direction*3)+'%)'},{opacity:1,transform:'translateX(0)'}]:[{opacity:0},{opacity:1}],{duration:350,easing:'ease-out'});this.animations=[a,b];a.finished.catch(()=>{}).then(()=>{if(epoch===this.epoch){old.hidden=true;old.removeAttribute('data-outgoing');}});
   }else old.hidden=true;
   if(manual)this.querySelector('[data-ehs-announcement]').textContent=this.dataset.slideLabel+' '+(index+1)+' '+this.dataset.ofLabel+' '+this.slides.length;
   this.sync();this.warm((index+1)%this.slides.length);
  }
  sync(){
   clearTimeout(this.timer);
   const control=this.querySelector('[data-ehs-pause]');if(control){control.setAttribute('aria-label',this.playing?this.dataset.pauseLabel:this.dataset.playLabel);}
   this.dataset.cycleState=!this.playing?'paused':this.loading?'loading':this.hovered?'hover':document.hidden?'hidden':!this.inView?'offscreen':'running';if(this.dataset.cycleState==='running')this.timer=setTimeout(()=>this.show(this.index+1),Math.max(4000,Number(this.dataset.interval)||7000));
  }
 }
 customElements.define('heading-collection-slideshow',CollectionHeadingSlideshow);
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heading-recommendations"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('heading-recommendations')) return;
  class HeadingRecommendations extends HTMLElement {
    static pending = new Set();
    static uncertain = new Set();
    static added = new Set();
    static cartDirty = false;
    static cartSequence = 0;
    static manualCartBusy = false;
    static inlineHost = null;

    connectedCallback() {
      if (this.active) return;
      this.active = true;
      this.lifecycle = new AbortController();
      this.busy = false;
      this.frame = null;
      this.addEventListener('click', (event) => this.onClick(event), { signal: this.lifecycle.signal });
      this.addEventListener('scroll', () => this.scheduleControls(), { capture: true, passive: true, signal: this.lifecycle.signal });
      window.addEventListener('pageshow', (event) => {
        if (event.persisted && !this.busy) this.load(true);
      }, { signal: this.lifecycle.signal });
      document.addEventListener('cart:updated', (event) => {
        if (Array.isArray(event.detail?.cart?.items)) {
          if (this.validCart(event.detail.cart)) {
            HeadingRecommendations.cartSequence += 1;
            HeadingRecommendations.cartDirty = false;
            this.updateCartIndicators(event.detail.cart);
          }
          const inCart = new Set(event.detail.cart.items.map((item) => String(item.variant_id || item.id)));
          for (const variant of HeadingRecommendations.added) {
            if (!inCart.has(variant)) HeadingRecommendations.added.delete(variant);
          }
        }
        if (this.dataset.state === 'ready' && !this.busy) this.load(true);
      }, { signal: this.lifecycle.signal });
      if (window.ResizeObserver) {
        this.resize = new ResizeObserver(() => this.scheduleControls());
        this.resize.observe(this);
      } else {
        window.addEventListener('resize', () => this.scheduleControls(), { signal: this.lifecycle.signal });
      }
      if (this.dataset.design === 'true' || !window.IntersectionObserver) {
        this.load();
      } else {
        this.intersection = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.intersection.disconnect();
            this.load();
          }
        }, { rootMargin: '600px 0px' });
        this.intersection.observe(this);
      }
    }

    disconnectedCallback() {
      this.active = false;
      this.lifecycle?.abort();
      this.request?.abort();
      this.request = null;
      this.loading = false;
      this.intersection?.disconnect();
      this.resize?.disconnect();
      this.impressions?.disconnect();
      if (this.frame !== null) cancelAnimationFrame(this.frame);
      this.frame = null;
    }

    async load(refresh = false) {
      if (!this.active || this.loading || (!refresh && this.dataset.state === 'ready')) return;
      const url = new URL(this.dataset.url, location.origin);
      const page = new URL(location.href);
      for (const key of ['preview_theme_id', 'view']) {
        if (page.searchParams.has(key)) url.searchParams.set(key, page.searchParams.get(key));
      }
      if (url.origin !== location.origin) return this.failed('error');
      this.loading = true;
      const hadContent = this.dataset.state === 'ready';
      const request = new AbortController();
      this.request = request;
      const timeout = setTimeout(() => request.abort(), 10000);
      if (!hadContent) this.dataset.state = 'loading';
      try {
        const response = await fetch(url, { credentials: 'same-origin', signal: request.signal });
        if (!response.ok) throw new Error('HTTP ' + response.status);
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = parsed.getElementById(this.id);
        if (!incoming || (incoming.dataset.product && incoming.dataset.product !== this.dataset.product) || incoming.dataset.intent !== this.dataset.intent) throw new Error('Section or product context mismatch');
        const template = incoming.querySelector('template[data-hpr-result]');
        if (!template) throw new Error('Recommendation template missing');
        const fragment = template.content.cloneNode(true);
        const seen = new Set([this.dataset.product]);
        let count = 0;
        for (const card of fragment.querySelectorAll('[data-hpr-card]')) {
          const id = card.dataset.product;
          const wrongType = this.dataset.sameType === 'true' && this.dataset.intent === 'related' && card.dataset.type !== this.dataset.sourceType;
          if (!/^\d+$/.test(id || '') || seen.has(id) || wrongType || count >= Number(this.dataset.limit)) {
            card.remove();
            continue;
          }
          seen.add(id);
          count += 1;
          const button = card.querySelector('[data-hpr-add]');
          if (button && HeadingRecommendations.uncertain.has(button.dataset.variant)) {
            button.disabled = true;
            button.textContent = this.dataset.checkCart;
            button.setAttribute('aria-label', this.dataset.checkCart + ': ' + (card.querySelector('.hpr__title')?.textContent.trim() || ''));
          }
          if (button && HeadingRecommendations.added.has(button.dataset.variant)) {
            button.disabled = true;
            button.textContent = this.dataset.added;
            button.setAttribute('aria-label', this.dataset.added + ': ' + (card.dataset.title || ''));
          }
        }
        if (!this.active || this.request !== request) return;
        if (!count) {
          this.replaceChildren();
          this.failed('empty');
          return;
        }
        this.replaceChildren(fragment);
        this.dataset.state = 'ready';
        this.removeAttribute('aria-hidden');
        this.classList.add('hpr--interactive');
        this.observeImpressions();
        this.scheduleControls();
      } catch (error) {
        if (!this.active || this.request !== request) return;
        if (!hadContent) this.failed('error', error.name === 'AbortError' ? 'Request timed out' : error.message);
      } finally {
        clearTimeout(timeout);
        if (this.request === request) this.loading = false;
      }
    }

    failed(state, detail = '') {
      this.dataset.state = state;
      this.setAttribute('aria-hidden', this.dataset.design === 'true' ? 'false' : 'true');
      if (this.dataset.design === 'true') {
        const note = document.createElement('p');
        note.className = 'hpr__editor-note';
        note.textContent = state === 'empty' ? this.dataset.empty : this.dataset.error;
        if (detail) note.append(' (' + detail + '). Save the theme changes, then reload the product preview.');
        this.replaceChildren(note);
      }
    }

    scheduleControls() {
      if (this.frame !== null) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.updateControls();
      });
    }

    updateControls() {
      const rail = this.querySelector('[data-hpr-rail]');
      const controls = this.querySelector('[data-hpr-controls]');
      if (!rail || !controls) return;
      const scrolling = getComputedStyle(rail).overflowX === 'auto' && rail.scrollWidth > rail.clientWidth + 2;
      controls.hidden = !scrolling;
      const cards = [...rail.children].filter((card) => card.classList.contains('hpr__card'));
      if (!cards.length) return;
      const box = rail.getBoundingClientRect();
      const imageBox = cards[0].querySelector('.hpr__image-link')?.getBoundingClientRect();
      if (imageBox) this.style.setProperty('--hpr-arrow-top', (imageBox.top + imageBox.height / 2 - this.querySelector('.hpr__inner').getBoundingClientRect().top) + 'px');
      const rtl = getComputedStyle(rail).direction === 'rtl';
      const first = cards[0].getBoundingClientRect();
      const last = cards[cards.length - 1].getBoundingClientRect();
      controls.querySelector('[data-hpr-prev]').disabled = rtl ? first.right <= box.right + 2 : first.left >= box.left - 2;
      controls.querySelector('[data-hpr-next]').disabled = rtl ? last.left >= box.left - 2 : last.right <= box.right + 2;
    }

    onClick(event) {
      const arrow = event.target.closest('[data-hpr-prev], [data-hpr-next]');
      if (arrow && this.contains(arrow)) {
        const rail = this.querySelector('[data-hpr-rail]');
        const card = rail?.querySelector('[data-hpr-card]');
        if (!rail || !card) return;
        const rtl = getComputedStyle(rail).direction === 'rtl';
        const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        const direction = arrow.hasAttribute('data-hpr-prev') ? -1 : 1;
        this.track(direction === 1 ? 'next' : 'previous');
        rail.scrollBy({ left: (card.getBoundingClientRect().width + gap) * direction * (rtl ? -1 : 1), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        return;
      }
      const button = event.target.closest('[data-hpr-add]');
      if (!button || !this.contains(button)) {
        const link = event.target.closest('a');
        const card = link?.closest('[data-hpr-card], [data-hpr-browse]');
        if (card && this.contains(card)) this.track(card.hasAttribute('data-hpr-browse') ? 'browse_collection' : 'open_product', card);
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      this.add(button);
    }

    track(action, card) {
      this.dispatchEvent(new CustomEvent('heading:recommendation', {
        bubbles: true,
        detail: {
          action,
          sectionId: this.id,
          intent: this.dataset.intent,
          productId: card?.dataset.product || null,
          variantId: card?.querySelector('[data-hpr-add]')?.dataset.variant || null,
          position: card ? [...card.parentNode.children].indexOf(card) + 1 : null,
          kind: card?.hasAttribute('data-hpr-browse') ? 'browse' : 'product'
        }
      }));
    }

    observeImpressions() {
      this.impressions?.disconnect();
      if (!window.IntersectionObserver) return;
      this.impressions = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting && entry.intersectionRatio >= .5) {
            this.track('impression', entry.target);
            this.impressions.unobserve(entry.target);
          }
        }
      }, { threshold: .5 });
      this.querySelectorAll('[data-hpr-card], [data-hpr-browse]').forEach((card) => this.impressions.observe(card));
    }

    markAdded(variant) {
      HeadingRecommendations.added.add(variant);
      for (const button of document.querySelectorAll('heading-recommendations [data-hpr-add]')) {
        if (button.dataset.variant !== variant) continue;
        const host = button.closest('heading-recommendations');
        button.disabled = true;
        button.textContent = host.dataset.added;
        button.setAttribute('aria-label', host.dataset.added + ': ' + (button.closest('[data-hpr-card]')?.dataset.title || ''));
      }
    }

    validCart(cart) {
      return Number.isSafeInteger(cart?.item_count) && cart.item_count >= 0 && Array.isArray(cart.items) &&
        cart.items.every((item) => Number.isSafeInteger(item.quantity) && item.quantity > 0) &&
        cart.items.reduce((total, item) => total + item.quantity, 0) === cart.item_count;
    }

    updateCartIndicators(cart) {
      document.querySelectorAll('[data-cart-count], .cart-link__bubble-num').forEach((count) => {
        count.textContent = String(cart.item_count);
        if (count.dataset.hprCountHidden === 'true') {
          count.hidden = false;
          delete count.dataset.hprCountHidden;
        }
      });
      document.querySelectorAll('.cart-link__bubble').forEach((bubble) => bubble.classList.toggle('cart-link__bubble--visible', cart.item_count > 0));
      document.querySelectorAll('a.js-drawer-open-cart').forEach((link) => link.setAttribute('aria-label', this.dataset.cartLabel.replace('__count__', String(cart.item_count))));
    }

    hideUnverifiedCount() {
      document.querySelectorAll('[data-cart-count], .cart-link__bubble-num').forEach((count) => {
        if (!count.hidden) { count.hidden = true; count.dataset.hprCountHidden = 'true'; }
      });
      document.querySelectorAll('a.js-drawer-open-cart').forEach((link) => link.setAttribute('aria-label', this.dataset.viewCart));
    }

    async syncInlineCart() {
      const sequence = ++HeadingRecommendations.cartSequence;
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 4000);
      try {
        const url = new URL(this.dataset.cartJsonUrl, location.origin);
        if (url.origin !== location.origin) throw new Error('cart origin');
        const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal });
        if (!response.ok) throw new Error('cart count');
        const cart = await response.json();
        if (!this.validCart(cart)) throw new Error('cart shape');
        if (sequence !== HeadingRecommendations.cartSequence) return;
        this.updateCartIndicators(cart);
      } catch (error) {
        if (sequence !== HeadingRecommendations.cartSequence) return;
        this.hideUnverifiedCount();
      } finally {
        clearTimeout(timer);
      }
    }

    async openNativeCart(trigger) {
      trigger.addEventListener('click', (event) => event.preventDefault(), { once: true, capture: true });
      trigger.click();
      const drawer = document.getElementById('CartDrawer');
      if (!drawer) return false;
      return new Promise((resolve) => {
        const isOpen = () => drawer.classList.contains('drawer--is-open') || drawer.getAttribute('aria-hidden') === 'false';
        if (isOpen()) return resolve(true);
        const observer = new MutationObserver(() => { if (isOpen()) { observer.disconnect(); clearTimeout(timer); resolve(true); } });
        const timer = setTimeout(() => { observer.disconnect(); resolve(isOpen()); }, 1000);
        observer.observe(drawer, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
      });
    }

    announce(text, error = false) {
      const status = this.querySelector('[data-hpr-status]');
      if (!status) return;
      status.dataset.error = String(error);
      status.replaceChildren(document.createTextNode(text + ' '));
      const link = document.createElement('a');
      link.href = this.dataset.cartUrl;
      link.textContent = this.dataset.viewCart;
      status.append(link);
    }

    async add(button) {
      const variant = button.dataset.variant;
      if (this.busy || button.disabled || !/^\d+$/.test(variant || '') || HeadingRecommendations.pending.has(variant) || HeadingRecommendations.uncertain.has(variant) || HeadingRecommendations.added.has(variant)) return;
      const originalMarkup = button.innerHTML;
      const started = performance.now();
      const originalName = button.getAttribute('aria-label');
      const productName = button.closest('[data-hpr-card]')?.querySelector('.hpr__title')?.textContent.trim() || '';
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      let confirmed = false;
      let retrySafe = false;
      this.busy = true;
      HeadingRecommendations.pending.add(variant);
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = this.dataset.adding;
      button.setAttribute('aria-label', this.dataset.adding + ': ' + productName);
      this.track('add_attempt', button.closest('[data-hpr-card]'));
      try {
        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1 }] }),
          signal: controller.signal
        });
        retrySafe = response.status === 422 || response.status === 400;
        const result = await response.json();
        if (!response.ok) {
          if (retrySafe) {
            this.track('add_rejected', button.closest('[data-hpr-card]'));
            this.announce(typeof result.description === 'string' ? result.description : this.dataset.addError, true);
            return;
          }
          throw new Error('uncertain');
        }
        if (!Array.isArray(result.items) || !result.items.some((item) => String(item.variant_id || item.id) === variant && item.quantity > 0)) throw new Error('uncertain');
        confirmed = true;
        this.markAdded(variant);
        if (!this.isConnected) return;
        this.track('add_success', button.closest('[data-hpr-card]'));
        this.announce(this.dataset.success);
        if (this.dataset.cartMode === 'inline') {
          HeadingRecommendations.cartDirty = true;
          HeadingRecommendations.inlineHost = this;
          document.querySelectorAll('.cart-link__bubble').forEach((bubble) => bubble.classList.add('cart-link__bubble--visible'));
          this.syncInlineCart();
          return;
        }
        if (this.dataset.cartMode === 'page') {
          location.assign(this.dataset.cartUrl);
          return;
        }
        if (!document.getElementById('CartDrawer')) {
          if (this.dataset.cartMode === 'archetype') location.assign(this.dataset.cartUrl);
          return;
        }
        const rebuilt = await this.rebuildArchetype(variant);
        const trigger = [...document.querySelectorAll('a.js-drawer-open-cart')].find((link) => link.getClientRects().length > 0 && !this.contains(link));
        if (!rebuilt || !trigger) {
          if (this.dataset.cartMode === 'archetype') location.assign(this.dataset.cartUrl);
          return;
        }
        const opened = await this.openNativeCart(trigger);
        if (!opened && this.dataset.cartMode === 'archetype') location.assign(this.dataset.cartUrl);
      } catch (error) {
        if (confirmed) {
          if (this.dataset.cartMode === 'page' || this.dataset.cartMode === 'archetype') location.assign(this.dataset.cartUrl);
          return;
        }
        this.track('add_uncertain', button.closest('[data-hpr-card]'));
        if (this.dataset.cartMode === 'inline') {
          HeadingRecommendations.cartSequence += 1;
          HeadingRecommendations.cartDirty = true;
          HeadingRecommendations.inlineHost = this;
          this.hideUnverifiedCount();
        }
        HeadingRecommendations.uncertain.add(variant);
        button.textContent = this.dataset.checkCart;
        button.setAttribute('aria-label', this.dataset.checkCart + ': ' + productName);
        this.announce(this.dataset.uncertain, true);
      } finally {
        clearTimeout(timeout);
        if (retrySafe && !confirmed) {
          button.innerHTML = originalMarkup;
          if (originalName) button.setAttribute('aria-label', originalName);
          await new Promise((resolve) => setTimeout(resolve, Math.max(0, 600 - (performance.now() - started))));
          button.disabled = false;
        }
        HeadingRecommendations.pending.delete(variant);
        this.busy = false;
        button.removeAttribute('aria-busy');
      }
    }

    async rebuildArchetype(variant = null) {
      const drawer = document.getElementById('CartDrawer');
      const form = drawer?.querySelector('#CartDrawerForm');
      if (!form) return false;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 3000);
      let cart;
      try {
        const url = new URL(this.dataset.cartJsonUrl, location.origin);
        if (url.origin !== location.origin) return false;
        const response = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal });
        if (!response.ok) return false;
        cart = await response.json();
        if (!this.validCart(cart) || (variant && !cart.items.some((item) => String(item.variant_id || item.id) === variant))) return false;
      } catch {
        return false;
      } finally {
        clearTimeout(timeout);
      }
      return new Promise((resolve) => {
        const previousItems = form.querySelector('.cart__items');
        let timer;
        const observer = new MutationObserver(() => {
          const items = form.querySelector('.cart__items');
          if (!items || items === previousItems || Number(items.dataset.count) !== cart.item_count) return;
          const quantities = [...items.querySelectorAll('input[id^="cart_updates_"]')];
          if (quantities.length !== cart.items.length || !cart.items.every((item) => quantities.some((input) => input.id === 'cart_updates_' + item.key && Number(input.value) === item.quantity))) return;
          observer.disconnect();
          clearTimeout(timer);
          resolve(true);
        });
        observer.observe(form, { childList: true, subtree: true });
        timer = setTimeout(() => { observer.disconnect(); resolve(false); }, 2500);
        document.dispatchEvent(new CustomEvent('cart:build'));
      });
    }
  }
  customElements.define('heading-recommendations', HeadingRecommendations);
  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('a.js-drawer-open-cart');
    const host = HeadingRecommendations.inlineHost;
    if (!trigger || trigger.closest('heading-recommendations') || !HeadingRecommendations.cartDirty || !host || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopPropagation();
    if (HeadingRecommendations.manualCartBusy) return;
    HeadingRecommendations.manualCartBusy = true;
    try {
      if (!document.getElementById('CartDrawer') || !await host.rebuildArchetype()) {
        location.assign(host.dataset.cartUrl);
        return;
      }
      HeadingRecommendations.cartDirty = false;
      if (!await host.openNativeCart(trigger)) location.assign(host.dataset.cartUrl);
    } catch (error) {
      location.assign(host.dataset.cartUrl);
    } finally {
      HeadingRecommendations.manualCartBusy = false;
    }
  }, true);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
